<template>
  <section class="content">
    <div class="loading-overlay" v-if="loading">
      <div class="spinner"></div>
      <h4>Loading Data...</h4>
    </div>
    <div class="box box-info" >
    <div class="p-toolbar p-component mb-4">
      <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()" v-if="this.supplierLists.length > 0">
        <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
        <span class="p-ink"></span>
      </button>
      <supplieraccountdialog ref="openDialog"/>
    </div>

      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable ref="po"
                     :value="supplierLists"
                     :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100"
                     :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
                     :selection.sync="selectedProduct1" selectionMode="single"
          >
            <Column header="S.N">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains">

              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Short Name"
                    field="shortName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['shortName']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Contact name" field="contactName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['contactName']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Contact Number" field="primaryContactNumber" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['primaryContactNumber']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Address" field="address" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Pan No" field="panNo" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['panNo']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Opn Balance"
                    field="openingBalance"
                    filterMatchMode="contains"
                    bodyStyle="text-align: right"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Dr-Cr"
                    field="openingDrCr"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Status"
                    field="status"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
              </template>
            </Column>
            <Column header="Action"  >
              <template #body="slotProps">
                <Button class="p-button-raised p-button-success" icon="pi pi-pencil"
                        @click="editSupplier(slotProps.data)"/>
                <Button class="p-button-raised p-button-danger" @click="openDialog(slotProps.data.id)"
                        icon="pi pi-trash"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/>
    </div>
  </section>
</template>
<script>
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import supplieraccountdialog from '../accountDialog/SupplierAccountDialog.vue'
import Button from 'primevue/button'

export default {
  name: 'supplier',
  data() {
    return {
      dialogShow: false,
      selectedProduct1: null,
      loading: true,
      columnList: '',
      filters: {}
    }
  },
  computed: {
    supplierLists() {
      return this.$store.state.accountMaster.supplierLists
    }
  },
  mounted() {
    this.supplierMasterList()
    this.columnNames()
  },
  methods: {
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    cancel(data) {
      this.dialogShow = false
    },
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteAccMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      }
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    async supplierMasterList() {
      this.loading = true
      try {
        let res = await this.$store.dispatch('loadSupplierAccountList')
        return res
      } finally {
        this.loading = false
      }
    },
    editSupplier(data) {
      this.$refs.openDialog.editSupplier(data)
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Supplier List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'supplierList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    supplieraccountdialog,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-overlay h4 {
  font-size: 1.5rem;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// SupplierAccount.vue?7dd19baa